import getApiClient from '@/plugins/api'

export default {

    loadPosts() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.search = {};

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage

        api.get(`/posts`, {
            params: self.search
        })
            .then((result) => {
                self.posts = [];
                self.posts = result.data['hydra:member'];
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    confirmDelete(itemId) {
        this.deletingId = itemId
        this.showDeleteConfirmation = true
    },

    cancelDelete() {
        this.deletingId = null
        this.showDeleteConfirmation = false
    },

    deletePost() {
        const self = this,
          api = getApiClient(self.$root.$store),
          itemId = self.deletingId

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage

        api.delete(`posts/${itemId}`)
          .then(() => {
              self.loadPosts()
              self.deletingId = null
              self.showDeleteConfirmation = false
          })
          .catch((error) => {
              console.log(error)
          })
          .finally(() => {
              self.$store.commit('stopLoading')
          })
    },

    changePage: function(page) {
        this.page = page
    },

}
